import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home/Home'
import Section from '@/views/Section/Section'
import Post from '@/views/Post/Post'
import List from '@/views/List/List'
import Intro from '@/views/Intro/Intro'
import Link from '@/views/Link/Link'
import Teach from '@/views/Teach/Teach'
import TeachPost from '@/views/Teach/TeachPost'

import ArtEdu1872subsidy from '@/views/Artedu1872/Subsidy'
import ArtEdu1872Class from '@/views/Artedu1872Class/Class'

import activity from '@/views/activity_school/activity'
import activity_post from '@/views/activity_school/activity_post'
import activity_results from '@/views/activity_results/activity_results'
import ApplicationForm from '@/views/ApplicationForm/ApplicationForm.vue'

import DataList from '@/views/Artedu1872/components/UploadData/DataList'
import MaintanList from '@/views/Artedu1872/components/UploadData/MaintanList'
import Maintain from '@/views/Artedu1872/components/UploadData/Maintain'
import Upload from '@/views/Artedu1872/components/UploadData/Upload'

import forgotPassword from '@/views/Reset'

import Search from '@/views/Search/search'
import LoginNow2 from '../views/activity_results/loginNow2.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/section/:pageid/category/:categoryid',
      name: 'Section',
      component: Section,
    },
    {
      path: '/post/:postid',
      name: 'Post',
      component: Post,
      props: true
    },
    {
      path: '/list/:listid',
      name: 'List',
      component: List
    },
    {
      path: '/project/:projectid',
      name: 'Intro',
      component: Intro
    },
    {
      path: '/link/:linkid',
      name: 'Link',
      component: Link
    },
    // {
    //   path: '/categories/:categoriesid',
    //   name: 'Categories',
    //   component: Categories
    // },
    // {
    //   path: '/newUser',
    //   name: 'Users',
    //   component: UserRegister
    // },
    // {
    //   path: '/users/login/:whichService',
    //   name: 'Login',
    //   component: UserLogin
    // },
    // {
    //   path: '/me',
    //   name: 'Profile',
    //   component: UserProfile
    // },
    // {
    //   path: '/forgot_passwords',
    //   name: 'forget_passwords',
    //   component: forget_passwords
    // },
    // {
    //   path: '/resetPassword/:email/:token',
    //   name: 'reset_passwords',
    //   component: reset_passwords
    // },
    {
      path: '/teach',
      name: 'Teach',
      component: Teach,
    },
    {
      path: '/forgotPassword',
      name: 'ForgotPassword',
      component: () => import('@/views/Reset'),
    },
    {
      path: '/teach/post/:postid',
      name: 'TeachPost',
      component: TeachPost,
    },
    {
      path: '/artedu1872/subsidy',
      name: 'ArtEdu1872subsidy',
      component: ArtEdu1872subsidy,
      children: [
        {
          path: 'grantList',
          name: 'GrantList',
          component: () => import('@/views/Artedu1872/components/GrantList')
        },
        {
          path: 'Detail',
          name: 'GrantDetailData',
          component: () => import('@/views/Artedu1872/components/GrantDetailData')
        },
        {
          path: 'createGrant',
          name: 'CreateGrant',
          component: () => import('@/views/Artedu1872/components/UploadData/Maintain')
        },
        {
          path: 'grantApplicationList',
          name: 'GrantApplicationList',
          component: () => import('@/views/Artedu1872/components/GrantApplicationList')
        },
        {
          path: 'applicationProcess',
          name: 'ApplicationProcess',
          component: () => import('@/views/Artedu1872/components/ApplicationProcess')
        },
        {
          path: 'applicationResult',
          name: 'ApplicationResult',
          component: () => import('@/views/Artedu1872/components/ApplicationResult')
        },
        {
          path: 'applicationDetail',
          name: 'ApplicationDetail',
          component: () => import('@/views/Artedu1872/components/ApplicationDetail')
        },
        {
          path: 'manual',
          name: 'Manual',
          component: () => import('@/views/Artedu1872/components/Manual')
        },
        {
          path: 'questions',
          name: 'Questions',
          component: () => import('@/views/Artedu1872/components/Questions')
        },
        {
          path: 'maintain',
          name: 'Maintain',
          component: () => import('@/views/Artedu1872/components/UploadData/Maintain'),
        },
        {
          path: 'upload',
          name: 'Upload',
          component: () => import('@/views/Artedu1872/components/UploadData/Upload'),
        },
        {
          path: 'uploadData',
          name: 'UploadData',
          component: () => import('@/views/Artedu1872/components/UploadData/DataList'),
          children: [
            // {
            // path: 'dataList',
            // name: 'DataList',
            // component: DataList,
            // },

            // {
            // path: 'upload',
            // name: 'Upload',
            // component: Upload,
            // }
          ]
        },
        {
          path: 'loginNow',
          name: 'LoginNow',
          component: () => import('@/views/Artedu1872/components/UploadData/Login')
        },
        {
          path: 'loginToMaintain',
          name: 'LoginToMaintain',
          component: () => import('@/views/Artedu1872/components/UploadData/MaintanList'),
          children: [

          ]
        },
        {
          path: 'rules',
          name: 'Rules',
          component: () => import('@/views/Artedu1872/components/Rules')
        }
      ],redirect: {
        name: 'GrantList'
      }
    },
    {
      path: '/artedu1872/class',
      name: 'ArtEdu1872Class',
      component: ArtEdu1872Class,
      children: [
        {
          path: 'classList',
          name: 'ClassList',
          component: () => import('@/views/Artedu1872Class/components/ClassList/Index')
        },
        {
          path: 'classApply',
          name: 'ClassApply',
          component: () => import('@/views/Artedu1872Class/components/classApply')
        },
        {
          path: 'classQuery',
          name: 'ClassQuery',
          component: () => import('@/views/Artedu1872Class/components/classQuery')
        },
        {
          path: 'classApplicationList',
          name: 'ClassApplicationList',
          component: () => import('@/views/Artedu1872Class/components/classApplicationList')
        },
        {
          path: 'classQuestions',
          name: 'ClassQuestions',
          component: () => import('@/views/Artedu1872Class/components/classQuestions')
        },
        {
          path: 'classFindArtEDU',
          name: 'ClassFindArtEDU',
          component: () => import('@/views/Artedu1872Class/components/classFindArtEDU')
        },
        {
          path: 'classFindArts',
          name: 'ClassFindArts',
          component: () => import('@/views/Artedu1872Class/components/classFindArts')
        },
        {
          path: 'fetchCourse',
          name: 'FetchCourse',
          component: () => import('@/views/Artedu1872Class/components/fetchCourse')
        },
        {
          path: 'loginNow',
          name: 'LoginNow',
          component: () => import('@/views/Artedu1872Class/components/loginNow')
        },

      ],redirect: {
        name: 'ClassList'
      }
    },

    {
      path: '/activity/results',
      name: 'activity_results',
      component: activity_results,
    },
    {
      path: '/activity/loginNow2',
      name: 'activity_loginNow2',
      component: LoginNow2,
    },
    {
      path: '/activity/school',
      name: 'activity',
      component: activity,
    },
    {
      path: '/activity/school/post/:postid',
      name: 'activity_post',
      component: activity_post
    },
    {
      path: '/applicationForm/:formId',
      name: 'applicationForm',
      component: ApplicationForm
    },
    {
      path: '/search',
      name: 'search',
      component: Search
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: () => import('@/views/NotFound'),
    }, {
      path: '*',
      redirect: '/not-found'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js